import { render, staticRenderFns } from "./FSCustomInput.vue?vue&type=template&id=200dc21e&"
import script from "./FSCustomInput.vue?vue&type=script&lang=js&"
export * from "./FSCustomInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports